<icon-salesforce *ngIf="type === MetricIntegrationName.Salesforce" class="icon"></icon-salesforce>
<icon-google-ads *ngIf="type === MetricIntegrationName.GoogleAds" class="icon"></icon-google-ads>
<fa-icon *ngIf="type === MetricIntegrationName.Hubspot" [icon]="['fab', 'hubspot']" class="icon"></fa-icon>
<fa-duotone-icon *ngIf="!type" [icon]="['fad', 'rocket-launch']" class="icon"></fa-duotone-icon>

<span [stringTruncate]="name"></span>
